

import React, { memo } from 'react';
import { Button, Dropdown } from '../../../../../../ui-kit';
import '../styles/_duration-dropdown.scss';








function Duration({
  duration,
  onChangeAddon,
  DURATIONS,
  disabled
}) {
  return (
    <div className="duration-dropdown">
      <Dropdown
        options={DURATIONS}
        value={
        duration ?
        DURATIONS &&
        DURATIONS.find((durationOption) => durationOption.value === duration) || null :
        null}

        label="Longform Edit"
        labelProps={{
          divContainer: true,
          extraLabelContent: !disabled && duration &&
          <Button
            type="TERTIARY"
            prefix="trash"
            onClick={() => {onChangeAddon('DURATION')(null);}} />


        }}
        onChange={onChangeAddon('DURATION')}
        showSelectedSuffix
        disabled={disabled}
        type="BUTTON"
        placeholder="Select a longform edit" />

    </div>);

}

export default memo(Duration);